module.exports = __webpack_public_path__ + "img/certif_013.03e58575.jpg";